import { createSelector } from '@ufc/core'

import type { TripPlanningIntakeState } from './intake.slice'

interface RootState {
  tripPlanningIntake: TripPlanningIntakeState
}

const selectState = (state: RootState) => state.tripPlanningIntake

export const selectIntakeResult = createSelector(selectState, (state) => state.result)
export const selectIntakeLoading = createSelector(selectState, (state) => state.loading)
export const selectIntakeError = createSelector(selectState, (state) => state.error)
